import { createPinia } from 'pinia';
import type { App } from 'vue';

const pinia = createPinia();

const setupStore = (app: App<Element>) => {
  app.use(pinia);
};

export {
  pinia,
  setupStore,
};
